<script lang="ts">
  import { type PageLayoutProps } from './PageLayout.vue'
  export interface PageLayoutPresetQueryTabsProps extends PageLayoutProps {
    tabs: TabItem[]
    defaultTab: string
    queryParam: string
  }
</script>
<script setup lang="ts">
  import { useRouteQuery } from '@gat-ship/lib/router'
  import PageLayout from './PageLayout.vue'
  import { GatTab, type TabItem } from '@gat-ship/vue-components'
  import { watch } from 'vue'

  const props = withDefaults(defineProps<PageLayoutPresetQueryTabsProps>(), {})

  const modelValue = defineModel<string>('activeTab', { required: false })

  const currentTab = useRouteQuery<string>(props.queryParam, modelValue.value)

  watch(
    currentTab,
    (value) => {
      modelValue.value = value
    },
    {
      immediate: true
    }
  )

  watch(
    () => props.tabs,
    (newTabs) => {
      if (newTabs.length === 0) {
        currentTab.value = props.defaultTab
      }
    }
  )
</script>
<template>
  <PageLayout v-bind="props">
    <template #actions>
      <slot name="actions" />
    </template>
    <div v-if="props.tabs.length > 0" class="flex flex-row items-center gap-2">
      <gat-tab
        :tabs="props.tabs"
        mode="model-value"
        :model-value="currentTab"
      />
      <slot name="append-tabs" />
    </div>
    <slot />
  </PageLayout>
</template>
